import { AxiosResponse, AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { AttributeBlacklistDefnId } from 'src/utils/Component/AttributeBlacklist.utils';

export function serverSuccessInterceptor(response: AxiosResponse<Record<string, any>>) {
  return response;
}

export function serverErrorInterceptor(error: AxiosError): Promise<Record<string, any>> {
  // `AttributeBlacklist` is specifically optional but attempts to fetch at app load
  // TODO: make the backend return 404 or make a version of this that doesn't toast on error
  if (error.response && error.response.status === 500 && !error.config?.url?.endsWith(AttributeBlacklistDefnId)) {
    const message: string = 'An error was encountered.' + (error.message ? ` Details: ${error.message}` : '');

    toast.error(message, {
      position: toast.POSITION.TOP_LEFT,
    });
  }

  return Promise.reject(error);
}
